import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { StreamrAppEmbedView } from '../components/streamrapp/StreamrAppEmbedView';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { StreamrAppService } from '../services/streamrapp/StreamrAppService';
/**
 * Watch-only page mounted at /embed/:streamId. Skips the lobby entirely:
 * the viewer engine is activated directly and the content partition is
 * joined as soon as the engine reports ready — the same end state a plain
 * viewer reaches through LobbyService's auto-dismissal, minus the
 * request-to-speak UI which must never appear in an embed.
 */
export function StreamrAppEmbedPage() {
    const activeBroadcast = BroadcastStateService.getOutput().useActiveBroadcast();
    const ready = StreamrAppService.getOutput().useReady();
    useEffect(() => {
        if (activeBroadcast === undefined) {
            return;
        }
        StreamrAppService.getInstance().notifyActivateBroadcast(activeBroadcast);
    }, [activeBroadcast]);
    useEffect(() => {
        if (!ready) {
            return;
        }
        // activateContentPartition is a silent no-op until the networking
        // worker exists, hence the gate on the engine-ready output.
        StreamrAppService.getInstance().notifyViewerLobbyDismissed();
    }, [ready]);
    if (activeBroadcast === undefined) {
        StreamrAppService.getInstance().notifyInitializeBroadcastFromUrl();
        return null;
    }
    return _jsx(StreamrAppEmbedView, {});
}
